import axios from 'axios'
import Nprogress from "nprogress";
import "nprogress/nprogress.css"; 
Nprogress.configure({ showSpinner: false }); // NProgress Configuration

// const baseURL = "https://wanxiangtest.phpbai.com/api"
const baseURL = "https://wanxiang2025.shanghaijiudao.com/api"
const service = axios.create({
    baseURL, //api的基础路径
    timeout: 30000, //超时时长
})
service.interceptors.request.use(
    config => {
        config.headers['Language'] = window.location.href.includes('/zh') ? 'cn' : 'en';
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
export default function (params) {
    return new Promise((resolve, reject) => {
        service(params).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error)
            console.error(error)
        })
    })
}
